export default "__VITE_ASSET__BqPEcmN8__"